.notice {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
  padding: var(--space-5);
}

.icon {
  display: grid;
  width: var(--space-12);
  height: var(--space-12);
  flex: none;
  border-radius: var(--radius-pill);
  color: var(--color-danger);
  background: var(--color-life-icon-bg);
  place-items: center;
}

.copy {
  display: grid;
  min-width: 0;
  flex: 1;
  gap: var(--space-2);
  text-align: left;
}

.title {
  color: var(--color-text-primary);
  font-family: var(--font-family-display);
  font-size: 1.125rem;
  line-height: 1.3;
}

.caption {
  max-width: var(--text-measure);
  color: var(--color-text-secondary);
  font-size: 0.8125rem;
  line-height: 1.5;
}

.recovery {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  color: var(--color-text-secondary);
  font-size: 0.8125rem;
}

.recovery strong {
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
  color: var(--color-text-primary);
  background: var(--color-surface-subtle);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.04em;
}

.action {
  flex: none;
}

@media (max-width: 47.99em) {
  .notice {
    flex-wrap: wrap;
    gap: var(--space-3);
    padding: var(--space-4);
  }

  .icon {
    display: none;
  }

  .copy {
    flex-basis: 100%;
    justify-items: center;
    text-align: center;
  }

  .title {
    font-size: 1rem;
  }

  .recovery {
    justify-content: center;
  }
}
